import { PxSizesValueType } from '../../formControls/Sizes/types'
import SvgText from './SvgText'
import { COLOR_ABS, COLOR_WHITE } from './constants'

interface ISvgPositionProps {
  left?: number
  top?: number
  right?: number
  bottom?: number
  offset: PxSizesValueType
  size: { width: number; height: number }
}

const SvgPosition: React.FC<ISvgPositionProps> = ({ left, top, right, bottom, size, offset }) => {
  const marginTop = offset[0] || 0
  const marginRight = offset[1] || 0
  const marginBottom = offset[2] || 0
  const marginLeft = offset[3] || 0

  return (
    <g>
      {typeof top === 'number' && typeof left === 'number' && (
        <SvgText
          background={COLOR_ABS}
          border={COLOR_ABS}
          color={COLOR_WHITE}
          gap={2}
          placement={['bottom', 'right']}
          rx={0}
          ry={0}
          text={`x:${Math.round(left)}, y:${Math.round(top)}`}
          x={left + marginLeft}
          y={top + marginTop}
        />
      )}
      {typeof top === 'number' && typeof right === 'number' && (
        <SvgText
          background={COLOR_ABS}
          border={COLOR_ABS}
          color={COLOR_WHITE}
          gap={2}
          placement={['bottom', 'left']}
          rx={0}
          ry={0}
          text={`x:${Math.round(right)}, y:${Math.round(top)}`}
          x={size.width - right - marginRight}
          y={top + marginTop}
        />
      )}
      {typeof bottom === 'number' && typeof left === 'number' && (
        <SvgText
          background={COLOR_ABS}
          border={COLOR_ABS}
          color={COLOR_WHITE}
          gap={2}
          placement={['top', 'right']}
          rx={0}
          ry={0}
          text={`x:${Math.round(left)}, y:${Math.round(bottom)}`}
          x={left + marginLeft}
          y={size.height - bottom - marginBottom}
        />
      )}
      {typeof bottom === 'number' && typeof right === 'number' && (
        <SvgText
          background={COLOR_ABS}
          border={COLOR_ABS}
          color={COLOR_WHITE}
          gap={2}
          placement={['top', 'left']}
          rx={0}
          ry={0}
          text={`x:${Math.round(right)}, y:${Math.round(bottom)}`}
          x={size.width - right - marginRight}
          y={size.height - bottom - marginBottom}
        />
      )}
    </g>
  )
}

export default SvgPosition
